module.exports = __webpack_public_path__ + "media/images/icons/footer-icon-twitter-hover-25212943058f0149dfda46f677237c8a.png";